import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/deELFBryk7XWUvcAHjCRJU/FONDO_2.png';
export function Hero() {
  return <section className="relative w-full min-h-[calc(100vh-180px)] flex items-center overflow-hidden py-20 px-6 bg-teal-dark bg-cover bg-center md:bg-right" style={{
    backgroundImage: `url('${HERO_IMAGE}')`,
    backgroundRepeat: 'no-repeat'
  }} data-id="element-160">
      {/* Mobile: full solid dark overlay for readability over centered geometry */}
      <div className="absolute inset-0 bg-teal-dark/70 md:hidden pointer-events-none" data-id="element-161" />

      {/* Desktop: gradient overlay fading from dark left to transparent right */}
      <div className="absolute inset-0 hidden md:block pointer-events-none" style={{
      background: 'linear-gradient(to right, rgba(8,32,31,0.85) 0%, rgba(8,32,31,0.6) 35%, rgba(8,32,31,0.2) 65%, rgba(8,32,31,0) 100%)'
    }} data-id="element-162" />

      <div className="relative max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 z-10" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-164">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-8 drop-shadow-md" data-id="element-165">
            Hay una capa más profunda en vos
            <br data-id="element-166" />
            que todavía no fue tocada.
          </h1>

          <p className="text-white/90 font-light text-lg md:text-xl mb-12 max-w-lg leading-relaxed" data-id="element-167">
            Depuración y restauración energética a distancia.
            <br data-id="element-168" />
            Sin videollamada. Sin presencial.
            <br data-id="element-169" />
            Solo tu nombre, tu fecha de nacimiento
            <br data-id="element-170" />y lo que querés trabajar — y el trabajo comienza.
          </p>

          <div className="flex flex-col items-center lg:items-start" data-id="element-171">
            <Link to="/sesiones" className="inline-block bg-gold text-teal font-medium px-10 py-4 rounded-full hover:bg-white transition-colors duration-300 tracking-wide mb-4 shadow-lg" data-id="element-172">
              QUIERO MI SESIÓN
            </Link>
            <p className="text-white/80 italic text-sm font-serif" data-id="element-173">
              100% a distancia · Para cualquier parte del mundo
            </p>
          </div>
        </motion.div>

        {/* Right column intentionally empty — the background image carries the visual */}
        <div className="hidden lg:block" aria-hidden="true" data-id="element-174" />
      </div>
    </section>;
}